export const auth = {
  signIn: 'Iniciar sesión',
  signOut: 'Cerrar sesión',
  twoFactor: 'Autenticación de dos factores',
  forgotPassword: '¿Olvidaste tu contraseña?',
};
